import { RouteObject } from 'react-router-dom';

import { Contact } from 'pages/contact';

import PrivateRoute from '../hoc/PrivateRoute';

export const contactRoutes: RouteObject[] = [
  {
    path: '/contact',
    element: (
      <PrivateRoute>
        <Contact />
      </PrivateRoute>
    ),
  },
];
